export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
// export const SERVER_URL = "http://64.227.116.212:8000/";
// export const SERVER_LOGS = "http://68.183.31.224:5000/";
